export default __webpack_public_path__ + "static/media/home-background.73690181.jpg";